module.exports = __webpack_public_path__ + "static/fonts/Alimama-ShuHeiTi-Bold.9268c32.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Alimama-ShuHeiTi-Bold.ttf
// module id = H8uu
// module chunks = 66